import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyToClipboardButton } from "./CopyToClipboardButton";
import { UnknownViewer } from "./ObjectViewer";
import { ViewerExpandDepthContext } from "./ViewerContext";
export function JsonViewer(props) {
    const { expandDepth = 1 } = props;
    const value = typeof props.src === "function" ? props.src() : props.src;
    return (_jsxs(ViewerExpandDepthContext.Provider, { value: expandDepth, children: [_jsx(CopyToClipboardButton, { data: value }), _jsx(UnknownViewer, { name: props.name, value: value })] }));
}
//# sourceMappingURL=JsonViewer.js.map